@if ((isOffline$ | async) === true) {
  <div class="isp-manual-offline-banner" data-cy="isp-manual-offline-banner">
    <qima-icon class="isp-manual-offline-banner__icon" [qimaIconName]="qimaIconNames.CONNECTION_OFFLINE" [qimaIconSize]="20"></qima-icon>
    <span class="isp-manual-offline-banner__text">{{ 'isp-manual-offline-banner.message' | translate }}</span>

    <button
      class="isp-manual-offline-banner__switch-online"
      type="button"
      [disabled]="(canSwitchOnline$ | async) !== true"
      (click)="onSwitchOnlineClick()"
      data-cy="isp-manual-offline-banner-switch-online"
    >
      {{ 'isp-manual-offline-banner.switch-online' | translate }}
    </button>
  </div>
}
